// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__5MrwK","background":"styles_background__1wxC4","white":"styles_white__UAvw9","line":"styles_line__1imUD"};